export default __webpack_public_path__ + "static/media/ceo.7cc987a6.png";